export const GET_REJECTEDVENDORS_REQUEST = "GET_REJECTEDVENDORS_REQUEST";
export const GET_REJECTEDVENDORS_SUCCESS = "GET_REJECTEDVENDORS_SUCCESS";
export const GET_REJECTEDVENDORS_FAILURE = "GET_REJECTEDVENDORS_FAILURE";